import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
    AddUser: [],
    LoginData: [],
    IsLogin: {},
    forgetPassword: {},
    ResetCode: {},
    ResetPassword : [],
    isLoading: true,
    isSuccess: true,
    errorMessage: ""
}

// register
export const register = createAsyncThunk("user/addNew", async (formData) => {
    try {
        const res = await baseUrl.post(`/api/v1/auth/signup`, formData)
        return res

    } catch (error) {
        return error
    }
})

// Login
export const Login = createAsyncThunk("user/login", async (formData) => {
    try {
        const res = await baseUrl.post(`/api/v1/auth/login`, formData)
        return res

    } catch (error) {
        return error
    }
})

// check logged user
export const LoggedUser = createAsyncThunk("user/loggged", async () => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get("/api/v1/users/getMe", config);
        return res;
    } catch (error) {
        return error;
    }
})

// forget password
export const ForgetPassword = createAsyncThunk("forgetpassword/user", async (formData) => {
    try {
        const res = await baseUrl.post("/api/v1/auth/forgotPasswords", formData)
        return res
    } catch (error) {
        return error
    }
})


// verfiy Mail
export const VerifyCode = createAsyncThunk("verifyCode", async (data) => {
    try {
        const res = await baseUrl.post("/api/v1/auth/verifyResetCode", data)
        return res
    } catch (error) {
        return error
    }
})

// reset password
export const ResetPasswordFunc = createAsyncThunk("resetPassword", async (data) => {
    try {
        const res = await baseUrl.put("/api/v1/auth/resetPassword", data)
        return res
    } catch (error) {
        return error
    }
})


const AuthSlice = createSlice({
    name: "Authentication",
    initialState,
    reducers: {},
    extraReducers: {
        [register.pending]: (state, action) => {
            state.isLoading = true
        },
        [register.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.AddUser = action.payload
        },
        [register.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [Login.pending]: (state, action) => {
            state.isLoading = true
        },
        [Login.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.LoginData = action.payload
        },
        [Login.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [LoggedUser.pending]: (state, action) => {
            state.isLoading = true
        },
        [LoggedUser.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.IsLogin = action.payload
        },
        [LoggedUser.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [ForgetPassword.pending]: (state, action) => {
            state.isLoading = true
        },
        [ForgetPassword.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.forgetPassword = action.payload
        },
        [ForgetPassword.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [VerifyCode.pending]: (state, action) => {
            state.isLoading = true
        },
        [VerifyCode.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.ResetCode = action.payload
        },
        [VerifyCode.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [ResetPasswordFunc.pending]: (state, action) => {
            state.isLoading = true
        },
        [ResetPasswordFunc.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.ResetPassword = action.payload
        },
        [ResetPasswordFunc.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
    }
})

export default AuthSlice.reducer;